import { render, staticRenderFns } from "./TokenPrompt.vue?vue&type=template&id=37a8e762"
import script from "./TokenPrompt.vue?vue&type=script&lang=js"
export * from "./TokenPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports